import React from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import AppComparison from './Sections/AppComparison/AppComparison'
import ProcessSection from './Sections/ProcessSection/ProcessSection'
import CaseStudies from '../../Home/Components/CaseStudies'
import Hero from './Sections/Hero/Hero'
import Industries from './Sections/Industries/Industries'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'
import Footer from '../../../Components/Footer/Footer'
import aiImage from '../../../assets/images/ai_ml.png'
import Subservices from './Sections/Subservices/Subservices'

const MCP = () => {

    const homeContent = {
        title: "Stop Building Broken AI Integrations That Waste Millions",
        description: "Dominate your market with KoolMind's battle-tested Model Context Protocol development, creating intelligent systems that connect AI models to real-world data without the integration nightmares destroying your competitors! Elite developers shipping enterprise-grade solutions across Singapore, Malaysia, Thailand and India.",
        image: aiImage,
        breadcrumb: "MCP Development",
        d1: "Ready to Stop Hemorrhaging Money on Failed AI Integrations?",
        d2: "Work with architects who've crushed every MCP challenge the industry can throw at them!",
        b: "Explore AI Solutions"
    }

    const subservicesTitles ={
        header: "We architect MCP integrations that obliterate the complexity, boosting your AI ambitions as you ship features at impossible speeds.",
        subservices: [
            {
                iconFileName: "s15.svg",
                title: "Custom MCP Server Development",
                subtitle: ""
            },
            {
                iconFileName: "s22.svg",
                title: "Enterprise Tool Integration",
                subtitle: ""
            },
            {
                iconFileName: "s16.svg",
                title: "Multi-Model Orchestration",
                subtitle: ""
            },
            {
                iconFileName: "s17.svg",
                title: "Real-Time Data Pipeline Architecture",
                subtitle: ""
            },
            {
                iconFileName: "s18.svg",
                title: "Security & Compliance Framework",
                subtitle: ""
            },
            {
                iconFileName: "s19.svg",
                title: "Scalable Infrastructure Design",
                subtitle: ""
            },
            {
                iconFileName: "s20.svg",
                title: "Performance Optimization & Monitoring",
                subtitle: ""
            },
            {
                iconFileName: "s21.svg",
                title: "MCP Strategy & Implementation Consulting",
                subtitle: ""
            }
        ]
    }

    const compareHeader = {
        title: "Why Legacy AI Integrations Are Costing You Millions (While MCP Saves On Everything)",
        description: "Discover the architecture that slashes development time by 50-70%, eliminates integration nightmares, and future-proofs your AI investments forever!"
    }

    const diff1 = {
        title: "Traditional AI Integration",
        features: [
            { text: "Reinvent the wheel for every single connection" },
            { text: "Data silos destroying AI performance" },
            { text: "Authentication chaos across platforms" },
            { text: "Every tool speaks a different language" },
            { text: "Maintenance costs spiraling out of control" },
            { text: "Scaling means starting from scratch" },
            { text: "Errors vanish into debugging black holes" },
            { text: "Troubleshooting kills developer productivity" },
            { text: "Locked into vendor ecosystems forever" },
            { text: "Innovation crawls at a painful pace" }
        ]
    }

    const diff2 = {
        title: "MCP Architecture",
        features: [
            { text: "One protocol that rules them all" },
            { text: "Unified context flowing seamlessly" },
            { text: "Single secure handshake everywhere" },
            { text: "Universal standard that just works" },
            { text: "Update once, benefit everywhere" },
            { text: "Add new tools in minutes, not months" },
            { text: "Crystal-clear error tracking built-in" },
            { text: "Self-documenting connections save hours daily" },
            { text: "Switch providers without breaking anything" },
            { text: "Ship AI features at lightning speed" }
        ]
    }

    const processSection = {
        title: "Process We Follow For MCP Excellence",
        description: "Leading AI companies across Asia trust KoolMind's MCP development methodology. We combine technical precision with strategic thinking. Our proven 6-step framework ensures integrations that not only function flawlessly but unlock transformative AI capabilities.",
        steps: [
            {
                title: "Requirements Analysis",
                description: "We conduct comprehensive discovery sessions analyzing your AI goals and data landscape thoroughly.",
                icon: "s12.svg"
            },
            {
                title: "Architecture Planning",
                description: "Our team designs robust MCP architectures optimized for your specific use cases and scale.",
                icon: "s13.svg"
            },
            {
                title: "Server Development",
                description: "Expert engineers build custom MCP servers with secure connections to your critical data sources.",
                icon: "s14.svg"
            },
            {
                title: "Integration Implementation",
                description: "We seamlessly connect AI models, tools, and resources through standardized MCP protocols.",
                icon: "s15.svg"
            },
            {
                title: "Testing & Validation",
                description: "Rigorous testing ensures reliability, security, and performance under real-world conditions.",
                icon: "s16.svg"
            },
            {
                title: "Deployment & Support",
                description: "Continuous monitoring and optimization keep your MCP infrastructure running at peak performance.",
                icon: "s17.svg"
            }
        ]
    }


    return (
        <div>
            <Navigation offer={true} />
            <Hero homeContent={homeContent} />
            <Subservices subservicesTitles={subservicesTitles} />
            <AppComparison compareHeader={compareHeader} diff1={diff1} diff2={diff2} />
            <ProcessSection processSection={processSection} />
            <CaseStudies />
            <Industries />
            <ClientSpeak />
            <GetQuote />
            <Contect />
            <Footer />
        </div>
    )
}

export default MCP